module.exports = __webpack_public_path__ + "img/12.a4bd1a22.webp";